import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { EA_FULL_ENDPOINTS } from "@ea/shared_types/next/ea.endpoints";
import { DEFAULT_LOCALE } from "@ea/shared_types/types";
import Backend from "i18next-http-backend";
// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    backend: {
      // for all available options read the backend's repository readme file
      loadPath: `/api/${EA_FULL_ENDPOINTS.localizations.sub.translations.endpoint.path}?locale={{lng}}&objectFormat=true`,
    },
    lng: DEFAULT_LOCALE,
    preload: [DEFAULT_LOCALE],
    fallbackLng: DEFAULT_LOCALE,
    debug: true,
    returnNull: false,
    defaultNS: "translations",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
